'use client';
import React, { memo } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { IButton, ITypo } from '@/app/_components/common';
import { ROUTERS } from '@/constants';
import { getImageUrl } from '@/utils';

interface IProps {
	item: any;
}

const CourseCard: React.FC<IProps> = (props) => {
	return (
		<div className="shadow-1 col rounded-3xl bg-white p-3">
			<div className="relative aspect-video w-full overflow-hidden rounded-xl">
				<Image
					src={getImageUrl(props?.item?.image).imageUrl}
					blurDataURL={
						getImageUrl(props?.item?.image).imagePlaceholder
					}
					placeholder="blur"
					alt={props?.item?.name || 'DLA Da Nang'}
					className="object-cover object-center"
					fill
				/>
			</div>
			<div className="col mb-3 mt-4 gap-2">
				<ITypo
					size={16}
					weight="semi"
					className="sm:text-20 line-clamp-1"
				>
					{props?.item?.name}
				</ITypo>
				<ITypo size={14} className="sm:text-16 line-clamp-3">
					{props?.item?.description}
				</ITypo>
			</div>
			<div className="row gap-3 max-lg:justify-center">
				<Link
					href={ROUTERS.COURSE_DETAIL.replace(
						':slug',
						props?.item?.slug
					)}
				>
					<IButton
						className="h-fit min-h-8 w-fit lg:h-9 lg:min-h-9"
						variant={'bordered'}
					>
						<ITypo size={14} className="">
							Xem thêm
						</ITypo>
					</IButton>
				</Link>
				<Link href={ROUTERS.CONTACT_SECTION}>
					<IButton className="h-fit min-h-8 w-fit lg:h-9 lg:min-h-9">
						<ITypo size={14} className="">
							Đăng ký tư vấn ngay
						</ITypo>
					</IButton>
				</Link>
			</div>
		</div>
	);
};

export default memo(CourseCard);
